import React from 'react';
import CustomCard from "../../../../components/Common/CustomCard";
import Content from './content';

const Support = () => {
    return (
        <CustomCard
            titleText={"Security"}
            className="from-security"
        >
            <Content />
        </CustomCard>
    )
}

export default Support;